import ReactModal from "react-modal";
import styled from "styled-components";

export const Container = styled.form`
  .popup-title {
    width: 100%;
    text-align: center;

    h1 {
      font-weight: 600;
      font-size: 3rem;
      color: var(--primary);
    }
  }

  .add-ingredient-container {
    display: flex;
    flex-direction: column;
    width: 100%;

    .file-upload-section {
      display: flex;
      flex-direction: column;

      h3 {
        font-size: 1.6rem;
        font-weight: 600;
        color: var(--text);
        margin: 0;
      }

      h4 {
        font-size: 1.4rem;
        font-weight: 500;
        color: var(--text);
        margin: 0.5rem 0;
      }

      .file-info {
        font-size: 1.4rem;
        color: var(--text-secondary);
        margin: 0;
      }

      .existing-documents,
      .new-documents {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        padding: 1.5rem;
        background-color: var(--light-gray);
        border-radius: 0.8rem;
      }

      .document-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1rem;
        background-color: var(--white);
        border-radius: 0.5rem;
        border: 0.1rem solid var(--border);

        .document-link {
          color: var(--primary);
          text-decoration: none;
          font-size: 1.4rem;
          word-break: break-all;

          &:hover {
            text-decoration: underline;
          }
        }

        .document-name {
          font-size: 1.4rem;
          color: var(--text);
          word-break: break-all;
        }

        .remove-doc-btn {
          background: none;
          border: none;
          cursor: pointer;
          padding: 0.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background-color 0.2s;
          border-radius: 0.3rem;

          &:hover {
            background-color: var(--background);
          }

          img {
            width: 1.5rem;
            height: 1.5rem;
          }
        }
      }

      .file-upload-button {
        margin-top: 1.5rem;
        padding: 1.5rem 2rem;
        background-color: var(--primary);
        color: var(--white);
        border: none;
        border-radius: 0.8rem;
        font-size: 1.6rem;
        font-weight: 500;
        cursor: pointer;
        transition: background-color 0.2s;

        &:hover:not(:disabled) {
          background-color: var(--secondary);
          color: var(--white);
        }

        &:disabled {
          background-color: var(--border);
          cursor: not-allowed;
        }
      }

      .error-message {
        color: #d32f2f;
        font-size: 1.4rem;
        padding: 1rem;
        background-color: #ffebee;
        border-radius: 0.5rem;
        border: 0.1rem solid #ffcdd2;
      }
    }
  }

  .add-button {
    width: 100%;
  }

  .close-button {
    position: absolute;
    top: 1rem;
    right: 1rem;
    background: none;
    border: none;
    cursor: pointer;
    z-index: 10;

    img {
      width: 2rem;
      height: 2rem;
    }
  }
`;

export const StyledReactModal = styled(ReactModal)`
  position: absolute;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  transform: translate(-50%, -50%);
  border-radius: 3rem;
  padding: 4rem;
  background: white;
  overflow: auto;
  outline: none;
  width: 70rem;
  max-width: 95vw;
  min-height: 40rem;

  @media (max-width: 768px) {
    width: 90%;
    padding: 3rem;
    min-height: 35rem;
  }

  @media (max-width: 425px) {
    width: 95%;
    padding: 2rem;
    min-height: 30rem;
  }
`;

